<template>
  <div class="pl-5 pr-5" data-test="hierarchy-inventory" :data-level="level">
    <h3>
      <!-- TKP-233 m.149–152: başlık seviyeye göre tek cümle (ilgili kişi adı başlığın içinde) -->
      <span data-test="hi-title">{{ title }}</span>
      <!-- TKP-203: aynı süreçteki başka bir veriden / ilgili kişiden özellikleri kopyala (kip Ekle) -->
      <b-button v-if="single && copyProcess" variant="outline-primary" size="sm" class="float-right" data-test="hi-copy-features" @click="$refs.copyDialog.open()">
        <i class="bx bx-copy"></i> {{ $t("inventory.copy.button") }}
      </b-button>
    </h3>
    <copy-features-dialog v-if="single && copyProcess" ref="copyDialog" :department="department" :process="copyProcess" :target-node-ids="datasubject ? [] : [node._id]" :target-row-ids="datasubject ? [datasubject._id] : []" @copied="load" />
    <!-- TKP-173: iki sekme — özellikler (hiyerarşik ekle/kaldır) ve Toplu Güncelleme (kapsam: birim + süreç, tüm alt varlıklar) -->
    <!-- TKP-196: "Toplu Güncelleme" sekmesi kapalı (kullanıcı 2026-10-09; kod duruyor, yeniden açmak için BULK_TAB_ENABLED = true) — tek sekmede sekme çubuğu gizli -->
    <b-tabs v-model="activeTab" :nav-class="bulkTabEnabled ? 'nav-tabs-custom' : 'd-none'" content-class="mt-2">
      <b-tab :title="$t('inventory.filter.inventory-features')">
    <!-- TKP-200 m.10: toplu güncelleme sekmesi kapalıyken onu anan ipuçları gösterilmez -->
    <!-- TKP-233 m.153: "Bu kapsamdaki tüm verilerde girilmiş kayıtlar; …" ipucu tüm seviyelerden kalktı -->
    <p v-if="single && bulkTabEnabled" class="text-muted small">{{ $t("process-data.inventory-panel.bulk-hint") }}</p>
    <!-- TKP-202 n.14: yalnız İLK yüklemede içerik yerine yükleme göstergesi; sonraki yenilemelerde bölümler yerinde kalır (kaydettikten
         sonra açık bölüm kapanıyordu — kartlar silinip yeniden kurulurken b-collapse `hide` yayıp açık durumu sıfırlıyordu) -->
    <content-loading v-if="loading && !loadedOnce" />
    <div v-else-if="loading" class="small text-muted mb-1" data-test="hi-refreshing"><i class="bx bx-loader bx-spin"></i></div>
    <template v-if="!loading || loadedOnce">
      <p v-if="!single" class="text-muted small" data-test="hierarchy-summary">{{ $t("inventory.hierarchy.summary", { nodes: nodeCount, rows: rowCount }) }}</p>
      <!-- TKP-188: dört seviyede TEK panel. Bölümler tekil değer satırları (`groupSectionItems`): birim/süreçte "N veride" sayısıyla,
           veri/ilgili kişide ilgili kişi adıyla (satır başına görünüm). Satır başına düzenleme yalnız tek veri kapsamında. -->
      <b-card v-for="s in sections" :key="s.key" no-body class="shadow-none mb-1" :data-test="'hi-section-' + s.key">
        <h4 class="p-3 hand text-muted m-0" v-b-toggle="acc(s.key)">
          <i class="align-middle" :class="chevron(acc(s.key))"></i>
          {{ $t(s.label) }} <span class="badge badge-light ml-1" data-test="hi-count">{{ s.groups.length }}</span>
        </h4>
        <!-- TKP-182 md.20/83: açılışta bütün bölümler kapalı; açık bölüm (`openSections`) yeniden yüklemede açık kalır -->
        <b-collapse :id="acc(s.key)" :visible="!!openSections[acc(s.key)]" :accordion="'hip-' + uid" class="border-top border-light" @show="setOpen(acc(s.key), true)" @hide="setOpen(acc(s.key), false)">
          <b-card-body>
            <!-- TKP-194: birim/süreç seviyesinde bölüm başına TEK ağaç — Birim › Süreç › Veri › İlgili kişi; her satırda o seviyenin değerleri,
                 "+ Ekle" ve değer çipinde kaldır / düzenle. Veri seviyesi bölümlerde ilgili kişi satırları soluk (bilgi). -->
            <template v-if="!single">
              <span v-if="!s.groups.length" class="text-muted d-block mb-1">{{ $t("common.no-data") }}</span>
              <div v-for="d in sectionTree(s)" :key="d.id" data-test="hi-tree-dept">
                <!-- birim satırı (birim seviyesi): kapsamın birleşik değerleri, tümünden kaldır, "+ Ekle" = kapsam "tümü" -->
                <div v-if="level === 'department'" class="mb-1" data-test="hi-tree-dept-row">
                  <i class="bx bx-buildings text-muted"></i> <b>{{ d.label }}</b>
                  <!-- TKP-196: birim/süreç satırında birleşik özet ("·N veride") yok; birim Ekle doğrudan tümü (ağaç yok) -->
                </div>
                <div :class="level === 'department' ? 'ml-4' : ''">
                <template v-for="p in d.children">
                  <div :key="p.id" class="mb-1" data-test="hi-tree-process">
                    <span class="hand" data-test="hi-tree-toggle" @click="toggleBranch(s.key, 'process', p.id)"><i class="bx" :class="branchOpen(s.key, 'process', p.id) ? 'bx-chevron-down' : 'bx-chevron-right'"></i> <i class="bx bx-git-branch text-muted"></i> <b>{{ p.label }}</b></span>
                    <div v-if="branchOpen(s.key, 'process', p.id)" class="ml-4">
                      <div v-for="n in p.children" :key="n.id" class="mb-1" data-test="hi-tree-node">
                        <span class="hand" data-test="hi-tree-toggle" @click="toggleBranch(s.key, 'node', n.id)"><i class="bx" :class="branchOpen(s.key, 'node', n.id) ? 'bx-chevron-down' : 'bx-chevron-right'"></i> <i class="bx bx-file text-muted"></i> {{ n.label }}</span>
                        <b-badge v-if="n.draft" variant="info" class="ml-1"><i class="bx bx-edit"></i> {{ $t("approval.badge.draft") }}</b-badge>
                        <!-- her bölümde veri satırından Ekle: ilgili kişi bölümlerinde verinin tüm satırları seçili (tek seçimlide satır sorulur) -->
                        <!-- TKP-222 p.1 (K7): özellik ilgili kişi bazında — veri satırında değer yalnız ilgili kişisi olmayan veride -->
                        <hi-values v-if="!n.children.length" :values="n.values" :headers="s.headers || null" :aggregated="false" :editable="nodeEditable(s.key)" @remove="(v) => removeIds(s.key, v.ids)" @edit="(v) => editNodeValue(s.key, v)" />
                        <div v-if="branchOpen(s.key, 'node', n.id)" class="ml-4">
                          <div v-for="r in n.children" :key="r.id" class="mb-1" data-test="hi-tree-row">
                            <i class="bx bx-user text-muted"></i> {{ r.label }}
                            <b-badge v-if="r.draft" variant="info" class="ml-1"><i class="bx bx-edit"></i> {{ $t("approval.badge.draft") }}</b-badge>
                            <!-- veri seviyesi bölüm: ilgili kişi satırından Ekle de var — kayıt VERİYE yazılır (ipucu); kalem yok -->
                            <!-- TKP-195: her özellik her seviyede — ilgili kişi satırında da + Ekle (kayıt SATIRA yazılır), değerler, 🗑/✎ -->
                            <template>
                              <hi-values :values="r.values" :headers="s.headers || null" :aggregated="false" :editable="rowEditable(s.key)" @remove="(v) => removeIds(s.key, v.ids)" @edit="(v) => editRowValue(s.key, v)" />
                            </template>
                          </div>
                        </div>
                      </div>
                      <div v-for="src in p.sources" :key="'src-' + src.id + src.text" class="mb-1 text-muted" data-test="hi-tree-source"><i class="bx bx-data"></i> {{ $t("datasource.text") }}: {{ src.label }} — {{ src.text }} <i class="bx bx-lock-alt ml-1" data-test="hi-source-readonly" v-b-tooltip.hover :title="$t('inventory.source-record-hint')"></i></div>
                    </div>
                  </div>
                </template>
                </div>
              </div>
            </template>
            <template v-else>
            <span v-if="!s.groups.length" class="text-muted d-block mb-1">{{ $t("common.no-data") }}</span>
            <!-- TKP-177 md.58: sütunlu bölümlerde başlık satırı (dört seviyede aynı sütunlar) -->
            <b-row v-if="s.headers && s.groups.length" class="mb-1 small text-muted font-weight-bold" data-test="hi-headers">
              <b-col v-if="showRowName(s)" md="3"></b-col>
              <b-col md="1"></b-col>
              <b-col :md="showRowName(s) ? 8 : 11"><b-row><b-col v-for="h in s.headers" :key="h">{{ $t(h) }}</b-col></b-row></b-col>
            </b-row>
            <template v-for="g in s.groups">
            <b-row :key="g.key" class="mb-1" data-test="hi-item">
              <!-- veri/ilgili kişi kapsamında ilgili kişi bölümleri satır adıyla (kriter 7) -->
              <b-col v-if="showRowName(s)" md="3" class="text-muted" data-test="hi-row-name">{{ levelLabel(g) }}<b-badge v-if="draftRow(g)" variant="info" class="ml-1" data-test="draft-row"><i class="bx bx-edit"></i> {{ $t(draftBadgeKey(draftRow(g))) }}</b-badge></b-col>
              <b-col md="1" class="text-nowrap">
                <!-- TKP-173 / TKP-188 kriter 5: değeri kapsamdaki tüm verilerden kaldır (tek veride tek kayıt) -->
                <i v-if="g.ids.length" class="bx bx-trash text-danger hand" data-test="hi-remove" v-b-tooltip.hover :title="g.ids.length > 1 ? $t('inventory.hierarchy.remove-all', { count: g.ids.length }) : $t('inventory.hierarchy.remove-one')" @click="removeGroup(s, g)"></i>
                <!-- TKP-192 kriter 6 (TKP-72/74 geri): veri kartında kaynağa bağlı kayıt uyarıyla silinir; birim/süreçte salt okunur -->
                <i v-else-if="single && g.sourceIds.length" class="bx bx-trash text-danger hand" data-test="hi-remove-source" v-b-tooltip.hover :title="$t('process-data.inventory-panel.datasource-scope-hint')" @click="removeSourceGroup(s, g)"></i>
                <!-- TKP-192 kriter 5: satır kalemleri tek kayıtlı değerde her seviyede (TKP-188 yalnız veri kapsamına indirmişti) -->
                <template v-if="g.single">
                  <i v-if="s.key === 'disposalPeriod' && g.single.nodeId" class="bx bx-pencil text-warning hand ml-1" data-test="hi-edit" v-b-tooltip.hover :title="$t('common.edit')" @click="g.single.rowId ? editRowPeriod(g.single) : editPeriod(g.single)"></i>
                  <!-- TKP-64: saklama kaydında başlangıç, süre, yasal dayanak ayrı düzenlenir -->
                  <i v-if="edit(s.key).retention && g.single.nodeId && g.single.item" class="bx bx-pencil text-warning hand ml-1" data-test="hi-retention" v-b-tooltip.hover :title="$t('storage-retention.edit')" @click="editRetention(s.key, g.single)"></i>
                  <!-- TKP-177 md.54/57: işleme / aktarım satırı düzenleme -->
                  <i v-if="edit(s.key).rowEdit && g.single.rowId && g.single.item" class="bx bx-pencil text-warning hand ml-1" data-test="hi-edit-row" v-b-tooltip.hover :title="$t('common.edit')" @click="editRow(s.key, g.single)"></i>
                  <!-- TKP-196 kriter 5: erişim kaydı tekil düzenleme -->
                  <i v-if="s.key === 'accessAndRestrictions' && g.single.nodeId && g.single.item" class="bx bx-pencil text-warning hand ml-1" data-test="hi-edit-access" v-b-tooltip.hover :title="$t('common.edit')" @click="editAccessItem(g.single)"></i>
                  <!-- TKP-177 md.53: tedbir (düğüm formu) ve otomatik işleme (satır formu) düzenleme -->
                  <i v-if="s.key === 'measures' && g.single.nodeId" class="bx bx-pencil text-warning hand ml-1" data-test="hi-edit-measures" v-b-tooltip.hover :title="$t('common.edit')" @click="g.single.rowId ? editRowMeasures(g.single) : editMeasures(g.single)"></i>
                  <i v-if="s.key === 'feature' && g.single.rowId" class="bx bx-pencil text-warning hand ml-1" data-test="hi-edit-feature" v-b-tooltip.hover :title="$t('common.edit')" @click="editFeature(g.single)"></i>
                </template>
                <i v-if="g.readonly && !(single && g.sourceIds.length)" class="bx bx-lock-alt text-muted" data-test="hi-source-readonly" v-b-tooltip.hover :title="$t(single ? 'process-data.inventory-panel.datasource-scope-hint' : 'inventory.source-record-hint')"></i>
              </b-col>
              <b-col :md="showRowName(s) ? 8 : 11">
                <b-row v-if="g.columns" data-test="hi-columns"><b-col v-for="(c, ci) in g.columns" :key="ci">{{ c || "—" }}</b-col></b-row>
                <del v-else-if="g.removal" class="text-muted" data-test="hi-removal">{{ g.text }}</del>
                <template v-else>{{ g.text }}</template>
                <!-- TKP-188 kriter 3: kapsamda kaç veride geçtiği (yalnız birim/süreç) -->
                <!-- TKP-193: "N veride" tıklanınca satırın altında Süreç › Veri › (İlgili kişi) ağacı açılır -->
                <b-badge v-if="!single && g.count" variant="light" class="ml-1 hand" data-test="hi-in-nodes" @click="toggleTree(s.key, g.key)"><i class="bx" :class="treeOpen(s.key, g.key) ? 'bx-chevron-down' : 'bx-chevron-right'"></i> {{ $t("inventory.hierarchy.in-nodes", { count: g.count }) }}</b-badge>
                <!-- TKP-186 md.16: taslağımdaki kayıt (onaylanınca envantere yazılır) -->
                <b-badge v-if="g.draft" variant="info" class="ml-1" data-test="hi-draft-item"><i class="bx bx-edit"></i> {{ $t(draftBadgeKey(draftItem(g))) }}</b-badge>
              </b-col>
            </b-row>
            <!-- TKP-193 kriter 3: açılır ağaç — yaprakta kaldır / düzenle -->
            <div v-if="treeOpen(s.key, g.key)" :key="g.key + '-tree'" class="ml-4 mb-2 small" data-test="hi-tree">
              <div v-for="p in groupTree(g)" :key="p.id" class="mb-1">
                <div v-if="level === 'department'" class="text-muted" data-test="hi-tree-process"><i class="bx bx-git-branch"></i> {{ p.label }}</div>
                <div :class="level === 'department' ? 'ml-3' : ''">
                  <div v-for="n in p.nodes" :key="n.id" class="mb-1" data-test="hi-tree-node">
                    <span><i class="bx bx-file text-muted"></i> {{ n.label }}</span>
                    <template v-if="n.items.length">
                      <i v-if="canRemoveAny(s.key, n.items)" class="bx bx-trash text-danger hand ml-2" data-test="hi-tree-remove" v-b-tooltip.hover :title="$t('inventory.hierarchy.remove-one')" @click="removeItems(s.key, n.items)"></i>
                      <i v-if="s.key === 'disposalPeriod'" class="bx bx-pencil text-warning hand ml-1" data-test="hi-tree-edit" v-b-tooltip.hover :title="$t('common.edit')" @click="editPeriod(n.items[0])"></i>
                      <i v-if="edit(s.key).retention && n.items[0].item" class="bx bx-pencil text-warning hand ml-1" data-test="hi-tree-edit" v-b-tooltip.hover :title="$t('storage-retention.edit')" @click="editRetention(s.key, n.items[0])"></i>
                      <i v-if="s.key === 'measures'" class="bx bx-pencil text-warning hand ml-1" data-test="hi-tree-edit" v-b-tooltip.hover :title="$t('common.edit')" @click="n.items[0] && n.items[0].rowId ? editRowMeasures(n.items[0]) : editMeasures(n.items[0])"></i>
                      <b-badge v-if="n.items.some((x) => x.item && x.item.__draft)" variant="info" class="ml-1"><i class="bx bx-edit"></i> {{ $t(draftBadgeKey(n.items.find((x) => x.item && x.item.__draft).item)) }}</b-badge>
                    </template>
                    <div v-for="r in n.rows" :key="r.id" class="ml-3" data-test="hi-tree-row">
                      <span><i class="bx bx-user text-muted"></i> {{ r.label }}</span>
                      <i v-if="canRemoveAny(s.key, r.items)" class="bx bx-trash text-danger hand ml-2" data-test="hi-tree-remove" v-b-tooltip.hover :title="$t('inventory.hierarchy.remove-one')" @click="removeItems(s.key, r.items)"></i>
                      <i v-if="edit(s.key).rowEdit && r.items[0].item" class="bx bx-pencil text-warning hand ml-1" data-test="hi-tree-edit" v-b-tooltip.hover :title="$t('common.edit')" @click="editRow(s.key, r.items[0])"></i>
                      <i v-if="s.key === 'feature'" class="bx bx-pencil text-warning hand ml-1" data-test="hi-tree-edit" v-b-tooltip.hover :title="$t('common.edit')" @click="editFeature(r.items[0])"></i>
                      <b-badge v-if="r.items.some((x) => x.item && x.item.__draft)" variant="info" class="ml-1"><i class="bx bx-edit"></i> {{ $t(draftBadgeKey(r.items.find((x) => x.item && x.item.__draft).item)) }}</b-badge>
                    </div>
                  </div>
                  <div v-for="src in p.sources" :key="'src-' + src.id" class="mb-1 text-muted" data-test="hi-tree-source"><i class="bx bx-data"></i> {{ $t("datasource.text") }}: {{ src.label }} <i class="bx bx-lock-alt ml-1" v-b-tooltip.hover :title="$t('inventory.source-record-hint')"></i></div>
                </div>
              </div>
            </div>
            </template>
            </template>
            <!-- ekleme: kapsam (birim/süreçte: tüm veriler ya da seçilen veriler) + ilgili kişi bölümlerinde satır seçimi, sonra form -->
            <div v-if="picker && picker.section === s.key" class="mt-2 p-2 border rounded" data-test="hi-picker">
              <!-- TKP-196: veri / ilgili kişi kartında da aynı ağaç (veri + ilgili kişileri) — standart seçim -->
              <template>
                <!-- TKP-195: "Kapsam" açılır kutusu kalktı — seçim yalnız ağaçtan ("Tümünü seç" bağlantısı kaldı); satır içi bölümde bütün
                     veriler seçiliyse istek eskisi gibi toplu uca kapsam "tümü" ile gider. TKP-186 md.101: onay açıkken toplu uç yok (veri başına taslak). -->
                <div v-if="perNodeDrafts" class="small text-info mb-2" data-test="hi-per-node-drafts"><i class="bx bx-edit"></i> {{ $t("inventory.hierarchy.per-node-drafts") }}</div>
                <!-- TKP-196: birim seviyesinde Ekle = doğrudan tümü (ağaç yok): birimin tüm süreç / veri / ilgili kişileri -->
                <!-- TKP-235 m.163: metin yeni; birim adıyla aynı ağırlıkta (kalın, normal boy) -->
                <div v-if="picker.direct" class="font-weight-bold mb-2" data-test="hi-direct-all"><i class="bx bx-buildings"></i> {{ $t("inventory.hierarchy.direct-all", { nodes: pickedNodes.length, rows: pickedRows.length }) }}</div>
                <template v-else>
                  <!-- TKP-177 md.52 / TKP-193: kademeli seçici — Süreç › Veri › (ilgili kişi bölümlerinde) İlgili kişi -->
                  <!-- TKP-235 m.164/166: kalın, süreç adıyla aynı boy; m.168: ilgili kişi seviyesinde gösterilmez (kişi zaten girilmiş) -->
                  <div v-if="rowsRequired && level !== 'datasubject'" class="font-weight-bold mb-1" data-test="hi-pick-rows-required"><i class="bx bx-info-circle text-info"></i> {{ $t("inventory.hierarchy.rows-required") }}</div>
                  <!-- TKP-235 m.165/167/169: "Kaydın yazılacağı verileri seçin." kalktı; bağlantılar kaldı -->
                  <div class="small mb-1"><span class="text-primary hand" data-test="hi-pick-all-nodes" @click="pickAllNodes()">{{ $t("inventory.hierarchy.select-all-nodes") }}</span> <span v-if="picker.nodeIds.length" class="text-muted hand ml-2" data-test="hi-pick-clear" @click="clearPick()">{{ $t("inventory.hierarchy.clear-pick") }}</span></div>
                  <div class="border rounded p-2 mb-1" style="max-height: 280px; overflow: auto;" data-test="hi-pick-tree">
                    <div v-for="p in pickTree(s.key)" :key="p.id" class="mb-1">
                      <b-form-checkbox v-if="level === 'department'" :checked="processState(p) === 'all'" :indeterminate="processState(p) === 'some'" class="d-block font-weight-bold" data-test="hi-pick-process" @change="(on) => toggleProcess(p, on)">{{ p.label }}</b-form-checkbox>
                      <div :class="level === 'department' ? 'ml-4' : ''">
                        <div v-for="n in p.nodes" :key="n.id">
                          <b-form-checkbox :checked="picker.nodeIds.includes(n.id)" :indeterminate="n.rows.length > 0 && nodeState(n) === 'some'" class="d-block" data-test="hi-pick-node" @change="(on) => toggleNode(n, on)">{{ n.label }}</b-form-checkbox>
                          <!-- TKP-194/195: tam hiyerarşi her bölümde — ilgili kişi satırları her bölümde SEÇİLEBİLİR (veri seçiliyken): satır işaretliyse
                               kayıt o satıra yazılır, işaretli satırı olmayan veri kendisine (en derin işaretli seviye). Satır içi çoklu kipte satır işaretliyse
                               istek toplu uca değil hedef başına tekil uçlara gider (toplu uç satır tanımaz). -->
                          <div v-if="n.rows.length" class="ml-4">
                            <b-form-checkbox v-for="r in n.rows" :key="r.id" v-model="picker.rowIds" :value="r.id" class="d-block" data-test="hi-pick-row" :disabled="edit(s.key).kind === 'datasubject' && !edit(s.key).multiple && !inlineMany(s.key) && picker.rowIds.length >= 1 && !picker.rowIds.includes(r.id)" @change="onRowToggle(r.id, n.id)">{{ r.label }} <small v-if="!picker.touched && (picker.cascadeRows || []).includes(r.id)" class="text-muted" data-test="hi-pick-row-cascade">{{ $t("inventory.hierarchy.row-cascade-hint") }}</small> <b-badge v-if="r.draft" variant="info"><i class="bx bx-edit"></i> {{ $t("approval.badge.draft") }}</b-badge></b-form-checkbox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- TKP-182 md.81: seçilen verilerin adları -->
                  <div v-if="scopeNodeIds.length" class="small text-muted mb-1" data-test="hi-picked-names"><b>{{ $t("inventory.hierarchy.targets-data", { count: pickedNodes.length }) }}:</b> {{ pickedNames.join(", ") }}<span v-if="pickedRowTargets.length" data-test="hi-picked-rows"> · <b>{{ $t("inventory.hierarchy.targets-rows", { count: pickedRowTargets.length }) }}:</b> {{ pickedRowTargets.map((r) => rowLabel(r)).join(", ") }}</span></div>
                </template>
              </template>
              <!-- TKP-177 md.52 / TKP-192 / TKP-196: satır içi bölümde kip (Ekle / Üzerine yaz / Kaldır) + seçici + Uygula HER seviyede (tek veri, ilgili kişi kartı dahil) -->
              <template v-if="inlineMany(s.key)">
                <select class="form-control form-control-sm mt-2 mb-2" v-model="picker.editOption" data-test="hi-pick-option">
                  <option value="ADD">{{ $t("inventory.bulk-update.edit-option.add") }}</option>
                  <option value="OVERRIDE">{{ $t("inventory.bulk-update.edit-option.override") }}</option>
                  <option value="REMOVE">{{ $t("inventory.bulk-update.edit-option.remove") }}</option>
                </select>
                <input v-if="inlineDef(s.key).number" type="number" min="0" class="form-control form-control-sm" v-model.number="picker.value" data-test="hi-pick-value" />
                <filter-select v-else :id="'hi-pick-items-' + uid + '-' + s.key" :placeholder="$t(s.label)" :multiple="true" @filter="(v, cb) => onInlineSearch(s.key, v, cb)" :selected="picker.items" @changed="(v) => (picker.items = v || [])" />
                <div v-if="inlineDef(s.key).newLabel" class="mt-1"><span class="text-primary hand small" data-test="hi-new-item" @click="openNewItem(s.key)"><i class="bx bx-plus"></i> {{ $t(inlineDef(s.key).newLabel) }}</span></div>
                <div v-if="inlineRowTargets" class="small text-info mt-1" data-test="hi-inline-rows"><i class="bx bx-user"></i> {{ $t("inventory.hierarchy.inline-rows-hint", { count: picker.rowIds.length }) }}</div>
              </template>
              <!-- ilgili kişi bölümleri: kapsamdaki satırlar (tümü seçilebilir); ilgili kişi kartında tek satır hazır seçili -->
              <template v-if="false"><!-- TKP-196: kartlardaki düz ilgili kişi listesi kalktı (ağaç her yerde) -->
                <div class="text-muted small mt-2 mb-1">
                  {{ $t(edit(s.key).multiple ? "process-data.inventory-panel.pick-datasubjects" : "process-data.inventory-panel.pick-datasubject") }}
                  <span v-if="edit(s.key).multiple && pickedRows.length > 1" class="text-primary hand ml-2" data-test="hi-pick-all-rows" @click="pickAllRows()">{{ $t("inventory.hierarchy.select-all-rows") }}</span>
                </div>
                <b-alert v-if="!pickedRows.length" show variant="warning" class="p-2">{{ $t("process-data.inventory-panel.no-datasubject") }}</b-alert>
                <div v-else class="border rounded p-2 mb-1" style="max-height: 220px; overflow: auto;">
                  <b-form-checkbox v-for="row in pickedRows" :key="row.nodeId + '-' + row._id" v-model="picker.rowIds" :value="String(row._id)" class="d-block" data-test="hi-pick-row">{{ rowLabel(row) }} <b-badge v-if="row.__draft" variant="info"><i class="bx bx-edit"></i> {{ $t(draftBadgeKey(row)) }}</b-badge></b-form-checkbox>
                </div>
                <div v-if="!edit(s.key).multiple && bulkTabEnabled" class="small text-muted mt-1">{{ $t("process-data.inventory-panel.single-hint") }}</div>
              </template>
              <!-- TKP-196: form bölümlerinde de kip — form hazırlama kipinde yükü verir, panel kipe göre yazar (Üzerine yaz: hedefin bölüm kayıtları silinir; Kaldır: ana alanla eşleşen silinir).
                   Toplu Güncelleme kısayolu kalktı. -->
              <select v-if="!isInline(s.key) && !edit(s.key).onlyOne" class="form-control form-control-sm mt-2" v-model="picker.editOption" data-test="hi-pick-option">
                <option value="ADD">{{ $t("inventory.bulk-update.edit-option.add") }}</option>
                <option value="OVERRIDE">{{ $t("inventory.bulk-update.edit-option.override") }}</option>
                <option value="REMOVE">{{ $t("inventory.bulk-update.edit-option.remove") }}</option>
              </select>
              <template>
                <button v-if="inlineMany(s.key)" class="btn btn-sm btn-success mt-2" :disabled="!inlineRequest(s.key) || applying" data-test="hi-apply" @click="applyInline(s.key)">{{ $t("inventory.hierarchy.apply") }}</button>
                <button v-else class="btn btn-sm btn-success mt-2" :disabled="!canContinue(s.key)" data-test="hi-continue" @click="startAdd(s.key)">{{ $t("common.continue") }}</button>
                <button class="btn btn-sm btn-secondary mt-2 ml-2" data-test="hi-cancel" @click="picker = null">{{ $t("common.cancel") }}</button>
              </template>
            </div>
            <span v-else-if="!edit(s.key).noAdd" class="text-primary hand" data-test="hi-add" @click="openPicker(s.key)"><i class="bx bx-plus"></i> {{ $t("inventory.hierarchy.edit-section") }}</span><!-- TKP-222 p.5: "Ekle" → "Düzenle" -->
          </b-card-body>
        </b-collapse>
      </b-card>
    </template>
      </b-tab>
      <b-tab v-if="bulkTabEnabled" :title="$t('inventory.bulk-update.text')" @click="openBulkScope">
        <!-- kapsam: birim (+ süreç) — düğüm listesi boş = alt varlıkların tümü (TKP-124 kriter 6 kuralı); veri/ilgili kişi: düğüm (+ satır) -->
        <BulkUpdateView v-if="bulkScoped" @onUpdated="onBulkUpdated" />
      </b-tab>
    </b-tabs>

    <!-- Formlar dört seviyede aynı (kimlikler bu panele özgü; kapanınca özet yeniden yüklenir). Kütüphane listeli formlar
         `onPick` ile kalemi panele verir: panel kapsamdaki her hedefe tekil yazar (`pickWritePlan`). -->
    <right-panel class="float-right" :id="pid('disposal-period')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><DisposalPeriodForm v-if="editNode" :id="pid('disposal-period')" :node="editNode" :prepareMode="multiNode" @onSave="onNodeSaved" @onPrepared="onPeriodPrepared" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('retention')" width="500px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><StorageRetentionForm :id="pid('retention')" :item="retentionItem" :kind="retentionKind" @onSaved="load" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('disposal-method')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><DataDisposalMethodForm :id="pid('disposal-method')" :onPick="onPick" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('access')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><div v-if="multiNode || addMode" class="mb-2"><label class="small text-muted mb-0">{{ $t("inventory.bulk-update.edit-option.text") }}</label><select class="form-control form-control-sm" v-model="pickEditOption" data-test="hi-form-option"><option value="ADD">{{ $t("inventory.bulk-update.edit-option.add") }}</option><option value="OVERRIDE">{{ $t("inventory.bulk-update.edit-option.override") }}</option><option value="REMOVE">{{ $t("inventory.bulk-update.edit-option.remove") }}</option></select></div><DataAccessAndRestrictionForm :id="pid('access')" :prepareMode="multiNode" @onSaved="onAccessPrepared" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('processing')" width="1000px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><div v-if="multiNode || addMode" class="mb-2"><label class="small text-muted mb-0">{{ $t("inventory.bulk-update.edit-option.text") }}</label><select class="form-control form-control-sm" v-model="pickEditOption" data-test="hi-form-option"><option value="ADD">{{ $t("inventory.bulk-update.edit-option.add") }}</option><option value="OVERRIDE">{{ $t("inventory.bulk-update.edit-option.override") }}</option><option value="REMOVE">{{ $t("inventory.bulk-update.edit-option.remove") }}</option></select></div><DatasubjectProcessingLegalForm :id="pid('processing')" :prepareMode="addMode" @onSaved="onProcessingPrepared" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('transfering')" width="1250px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><div v-if="multiNode || addMode" class="mb-2"><label class="small text-muted mb-0">{{ $t("inventory.bulk-update.edit-option.text") }}</label><select class="form-control form-control-sm" v-model="pickEditOption" data-test="hi-form-option"><option value="ADD">{{ $t("inventory.bulk-update.edit-option.add") }}</option><option value="OVERRIDE">{{ $t("inventory.bulk-update.edit-option.override") }}</option><option value="REMOVE">{{ $t("inventory.bulk-update.edit-option.remove") }}</option></select></div><DatasubjectTransferingForm :id="pid('transfering')" :prepareMode="addMode" @onSaved="onTransferingPrepared" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('direct-collect')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><DatasourceDirectCollectMethodForm :onPick="onPick" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('other-collect')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><DatasourceOtherCollectMethodForm :onPick="onPick" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('physical-storage')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><div v-if="multiNode || addMode" class="mb-2"><label class="small text-muted mb-0">{{ $t("inventory.bulk-update.edit-option.text") }}</label><select class="form-control form-control-sm" v-model="pickEditOption" data-test="hi-form-option"><option value="ADD">{{ $t("inventory.bulk-update.edit-option.add") }}</option><option value="OVERRIDE">{{ $t("inventory.bulk-update.edit-option.override") }}</option><option value="REMOVE">{{ $t("inventory.bulk-update.edit-option.remove") }}</option></select></div><DatasourcePhysicalStorageForm :id="pid('physical-storage')" :prepareMode="multiNode" :existing="storageExisting('physicalStorages')" @onSaved="(p) => onStoragePrepared('physicalStorages', p)" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('electronic-storage')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><div v-if="multiNode || addMode" class="mb-2"><label class="small text-muted mb-0">{{ $t("inventory.bulk-update.edit-option.text") }}</label><select class="form-control form-control-sm" v-model="pickEditOption" data-test="hi-form-option"><option value="ADD">{{ $t("inventory.bulk-update.edit-option.add") }}</option><option value="OVERRIDE">{{ $t("inventory.bulk-update.edit-option.override") }}</option><option value="REMOVE">{{ $t("inventory.bulk-update.edit-option.remove") }}</option></select></div><DatasourceElectronicStorageForm :id="pid('electronic-storage')" :prepareMode="multiNode" :existing="storageExisting('electronicStorages')" @onSaved="(p) => onStoragePrepared('electronicStorages', p)" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('physical-archive')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><DatasourcePhysicalArchiveForm :onPick="onPick" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('electronic-archive')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><DatasourceElectronicArchiveForm :onPick="onPick" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('right')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><DatasubjectDatasubjectRightForm :onPick="onPick" /></div>
    </right-panel>
    <!-- TKP-177 md.53: tedbirler (veri kartındaki form; çoklu veride hazırlama kipi) ve otomatik işleme (ilgili kişi satırı formu) -->
    <right-panel class="float-right" :id="pid('measures')" width="700px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><div v-if="multiNode" class="mb-2"><label class="small text-muted mb-0">{{ $t("inventory.bulk-update.edit-option.text") }}</label><select class="form-control form-control-sm" v-model="pickEditOption" data-test="hi-form-option"><option value="ADD">{{ $t("inventory.bulk-update.edit-option.add") }}</option><option value="OVERRIDE">{{ $t("inventory.bulk-update.edit-option.override") }}</option><option value="REMOVE">{{ $t("inventory.bulk-update.edit-option.remove") }}</option></select></div><InventoryNodeMeasuresForm v-if="measuresNode" :id="pid('measures')" :node="measuresNode" :prepareMode="multiNode" :hideTarget="true" @onSaved="onNodeSaved" @onPrepared="onMeasuresPrepared" /></div>
    </right-panel>
    <!-- TKP-182 md.26/30/31/32 (TKP-192 geri): satır içi seçiciden kütüphaneye yeni kalem; kapanınca özet YENİDEN YÜKLENMEZ (seçici açık kalır) -->
    <right-panel class="float-right" :id="pid('new-item')" width="800px">
      <div class="pl-5 pr-5"><component v-if="newItemKey" :is="newItemForm" :hide-library="true" :inventory="true" data-test="hi-new-item-form" @onFormSave="onInlineItemCreated" /></div>
    </right-panel>
    <!-- TKP-196 kriter 5: tek işleme kaydını düzenle (amaç / hukuki sebep / meşru menfaat) -->
    <right-panel class="float-right" :id="pid('processing-item')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><ProcessingItemForm v-if="itemEdit" :id="pid('processing-item')" :item="itemEdit.item" :items="itemEdit.items" :row="itemEdit.row" @onSaved="load" /></div>
    </right-panel>
    <right-panel class="float-right" :id="pid('feature')" width="600px" @hidden="load">
      <div class="pl-5 pr-5"><InventoryTargets :targets="targets" /><div v-if="addMode" class="mb-2"><label class="small text-muted mb-0">{{ $t("inventory.bulk-update.edit-option.text") }}</label><select class="form-control form-control-sm" v-model="pickEditOption" data-test="hi-form-option"><option value="ADD">{{ $t("inventory.bulk-update.edit-option.add") }}</option><option value="OVERRIDE">{{ $t("inventory.bulk-update.edit-option.override") }}</option><option value="REMOVE">{{ $t("inventory.bulk-update.edit-option.remove") }}</option></select></div><DataSubjectAutoProcessingForm :id="pid('feature')" :prepareMode="addMode" @onSaved="onFeatureSaved" @onPrepared="onFeaturePrepared" /></div>
    </right-panel>
  </div>
</template>

<script>
import rest from "@/rest-client";
import DataAccessAndRestrictionForm from "@modules/inventory/component/access-and-restriction/data-access-and-restriction-form";
import DatasubjectDatasubjectRightForm from "@modules/inventory/component/datasubject-right/datasubject-datasubject-right-form";
import DataDisposalMethodForm from "@modules/inventory/component/disposal-method/data-disposal-method-form";
import StorageRetentionForm from "@modules/inventory/component/retention/storage-retention-form";
import DatasubjectProcessingLegalForm from "@modules/inventory/component/processing/datasubject-legal-form";
import ProcessingItemForm from "@modules/inventory/component/processing/processing-item-form"; // TKP-196
import DatasubjectTransferingForm from "@modules/inventory/component/transfering/datasubject-transfering-form";
import DatasourceDirectCollectMethodForm from "@modules/inventory/component/direct-collect-method/datasource-direct-collect-method-form";
import DatasourceOtherCollectMethodForm from "@modules/inventory/component/other-collect-method/datasource-other-collect-method-form";
import DatasourcePhysicalStorageForm from "@modules/inventory/component/physical-storage/datasource-physical-storage-form";
import DatasourceElectronicStorageForm from "@modules/inventory/component/electronic-storage/datasource-electronic-storage-form";
import DatasourcePhysicalArchiveForm from "@modules/inventory/component/physical-archive/datasource-physical-archive-form";
import DatasourceElectronicArchiveForm from "@modules/inventory/component/electronic-archive/datasource-electronic-archive-form";
import DisposalPeriodForm from "@modules/process-data/component/process-data-disposal-period-form";
import InventoryNodeMeasuresForm from "@modules/inventory/component/node/inventory-node-measures-form"; // TKP-177 md.53
import DataSubjectAutoProcessingForm from "@modules/inventory/component/processing/datasubject-auto-processing-form"; // TKP-177 md.53
import { nodeScopeCommits, panelScope } from "@modules/process-data/inventory-panel";
import { accessKipPlan, measuresKipPlan, processingKipPlan, storageKipPlan, transferingKipPlan } from "./hierarchy-kip"; // TKP-196
import { canRemoveItem, flattenNodes, groupSectionItems, groupTree, hierarchyCriteria, hierarchySections, levelOf, nodeOf, nodeOptions, onlyNodesWithRows, pickerTree, processDatasources, restrictScope, rowsOfNodes, SECTION_EDIT, sectionTree, selectionState, toggleIds } from "./hierarchy-inventory";
import BulkUpdateView from "@modules/inventory/component/bulk-update/bulk-update-view";
/** TKP-196: panelin "Toplu Güncelleme" sekmesi — şimdilik kapalı; yeniden açmak için true. */
const BULK_TAB_ENABLED = false;
import { clipTargets, runInBackground, withDraftBatch } from "@/modules/approval/draft-batch"; // TKP-237 t.8, TKP-242
import { bulkRequestFor, hierarchyScopeCommits, INLINE_SECTIONS, isInlineSection, periodWritePlan, perNodeInlinePlan, pickWritePlan, processingLegalSourceOf, rowToggleSelection, hasPartialRows, targetsOf, withCreatedItem, writeTargets } from "./hierarchy-bulk"; // TKP-173, TKP-177, TKP-182, TKP-186, TKP-188, TKP-192, TKP-195
import { bulkLocked } from "@/modules/approval/bulk-lock"; // TKP-186 md.101
// TKP-182 md.26/30/31/32: satır içi seçicinin "yeni … oluştur" formları (tekil formlardaki kütüphane formlarıyla aynı)
import FormDisposalMethod from "@modules/storage-environments/disposal-method/workspace-library-disposal-method-form";
import FormPhysicalArchive from "@modules/archive-environments/physical-archive/workspace-library-physical-archive-form";
import FormElectronicArchive from "@modules/archive-environments/electronic-archive/workspace-library-electronic-archive-form";
import FormDatasubjectRight from "@modules/datasubject-right/workspace-library-datasubject-right-form";
import FormDirectCollectMethod from "@modules/collect-method/workspace-library-direct-collect-method-form";
import FormOtherCollectMethod from "@modules/collect-method/workspace-library-other-collect-method-form";

const NEW_ITEM_FORMS = { disposalMethods: FormDisposalMethod, physicalArchives: FormPhysicalArchive, electronicArchives: FormElectronicArchive, datasubjectRights: FormDatasubjectRight, directCollectMethods: FormDirectCollectMethod, otherCollectMethods: FormOtherCollectMethod };
import InventoryTargets from "./inventory-targets"; // TKP-182 md.52/81
import CopyFeaturesDialog from "./copy-features-dialog"; // TKP-203
import HiValues from "./hi-values"; // TKP-194: ağaç satırı değerleri (tablo / çip)
import { draftBadgeKey, draftNodeMeasuresOf, editableLegals, overlayDatasubjectInventory, overlayNodeInventory, withShadowNodes, withShadowRows } from "@modules/approval/draft-overlay"; // TKP-186 md.16

let seq = 0;

/**
 * TKP-128/161/173/177/182/186 → TKP-188: Varlıklar'daki DÖRT kutunun (birim, süreç, veri, ilgili kişi) "Envanter Özellikleri"
 * paneli — tek bileşen, tek kod yolu. Seviyeye göre değişen yalnız KAPSAM: birim/süreç alttaki tüm veriler, veri tek düğüm,
 * ilgili kişi düğümün tek satırı. Bölümler, sıra (inventory-panel-order.js), sütunlar ve formlar her seviyede aynı.
 * Birim/süreçte satırlar tekil değer + "N veride"; veri/ilgili kişide satır başına (ilgili kişi adıyla) görünüm ve düzenleme.
 * Ekleme her seviyede aynı yan panel formu; yazım kapsamdaki her hedefe tekil uçla (toplu güncelleme ucu yalnız Toplu Güncelleme sekmesinde).
 * Özet için store'a YAZMAZ (Envanter ekranının durumu ezilmesin); formlar kendi store'larına yazar, her kapanışta özet yeniden yüklenir.
 */
export default {
  name: "hierarchy-inventory-view",
  components: {
    DataAccessAndRestrictionForm, DatasubjectDatasubjectRightForm, DataDisposalMethodForm, StorageRetentionForm,
    DatasubjectProcessingLegalForm,
    ProcessingItemForm, DatasubjectTransferingForm, DatasourceDirectCollectMethodForm, DatasourceOtherCollectMethodForm,
    DatasourcePhysicalStorageForm, DatasourceElectronicStorageForm, DatasourcePhysicalArchiveForm, DatasourceElectronicArchiveForm, DisposalPeriodForm, BulkUpdateView,
    InventoryNodeMeasuresForm, DataSubjectAutoProcessingForm, // TKP-177
    InventoryTargets, // TKP-182
    HiValues, // TKP-194
    CopyFeaturesDialog, // TKP-203
  },
  // TKP-188: `node` (veri kartı: süreç×veri düğümü) ve `datasubject` (ilgili kişi kartı: düğümün satırı) kapsamı daraltır
  props: { department: { type: Object, required: true }, process: { type: Object, default: null }, node: { type: Object, default: null }, datasubject: { type: Object, default: null }, reload: { type: Number, default: 0 } },
  data() {
    return {
      uid: ++seq, loading: false, departments: [], nodeInventory: {}, datasourceInventory: {}, datasubjectInventory: {},
      openSections: {}, loadedOnce: false, picker: null, editNode: null, retentionItem: null, retentionKind: "physical", addMode: false, pendingRowIds: [],
      activeTab: 0, bulkScoped: false, bulkTabEnabled: BULK_TAB_ENABLED, criteriaBefore: null, applying: false, // TKP-173
      multiNode: false, prepareNodeIds: [], prepareRowIds: [], measuresNode: null, // TKP-195: prepareRowIds — hazırlama kipinde hedef ilgili kişi satırları // TKP-177 md.52/53: çoklu veri hazırlama kipi, tedbir formu düğümü
      targets: null, storageNodeId: null, pickSection: null, pickNodeIds: [], pickRowIds: [], pickEditOption: "ADD", itemEdit: null, // TKP-196: form bölümlerinde kip // TKP-182 hedef adları; TKP-188 kütüphane formu kalem hedefleri
      newItemKey: null, // TKP-182 / TKP-192: satır içi "yeni oluştur" bölümü
      openTrees: {}, // TKP-193: açık değer ağaçları (bölüm:grup)
      openNodes: {}, // TKP-194: tek ağaçta açık satırlar (bölüm|tür:kimlik); süreç satırları açılışta kapalı
    };
  },
  computed: {
    level() {
      return levelOf({ process: this.process, node: this.node, datasubject: this.datasubject });
    },
    /** Tek düğüm kapsamı (veri / ilgili kişi kartı): kapsam seçimi yok, satır başına görünüm ve düzenleme. */
    single() {
      return !!this.node;
    },
    basePath() {
      return this.currentProduct == "GDPR" ? "/gdpr/inventory" : "/kvkk/inventory";
    },
    title() {
      const tr = this.$options.filters.translate;
      const data = this.node && tr(this.node.data && this.node.data.name);
      if (this.node && this.datasubject) return this.$t("process-data.inventory-row", { data, datasubject: tr(this.datasubject.name) });
      if (this.node) return this.$t("process-data.inventory", { data });
      return this.process ? this.$t("inventory.hierarchy.title-process", { name: tr(this.process.name) }) : this.$t("inventory.hierarchy.title-department", { name: tr(this.department.name) });
    },
    nodeCount() {
      return flattenNodes(this.departments).length;
    },
    rowCount() {
      return flattenNodes(this.departments).reduce((n, e) => n + (e.node.datasubjects || []).length, 0);
    },
    rawSections() {
      const tr = (v) => this.$options.filters.translate(v) || "";
      const period = (v) => this.$options.filters.period(v);
      return hierarchySections({
        departments: this.departments,
        nodeInventory: this.nodeInventory,
        datasourceInventory: this.datasourceInventory,
        datasubjectInventory: this.datasubjectInventory,
        level: this.level === "department" ? "department" : "process",
        fmt: { tr, period, source: this.$t("datasource.text"), unspecified: this.$t("inventory.hierarchy.unspecified"), auto: this.$t("processing.auto"), ai: this.$t("processing.ai"), yes: this.$t("common.yes"), no: this.$t("common.no") },
      });
    },
    /** TKP-188 kriter 3/6/7: bölüm satırları tekil değer grupları. */
    sections() {
      return this.rawSections.map((s) => ({ ...s, groups: groupSectionItems(s.items, { byRow: this.single, sectionKey: s.key }) }));
    },
    options() {
      return nodeOptions(this.departments, (v) => this.$options.filters.translate(v) || "");
    },
    /** TKP-233 m.148 / TKP-235 m.193: her seviyede yalnız ilgili kişisi olan veri seçilir — birim seviyesi dahil (kişisiz veriye yazılmıyordu sanılıyordu, yazılıyordu). */
    rowsRequired() {
      return true;
    },
    pickableNodeIds() {
      const tree = pickerTree(this.departments, this.tr, { withRows: true });
      return (this.rowsRequired ? onlyNodesWithRows(tree) : tree).flatMap((p) => p.nodes.map((n) => n.id));
    },
    /** Seçicinin veri kapsamı: tek düğümde düğümün kendisi; birim/süreçte "tümü" ya da seçilenler. */
    scopeNodeIds() {
      if (!this.picker) return [];
      if (this.single) return this.pickableNodeIds.includes(String(this.node._id)) ? [String(this.node._id)] : []; // TKP-233 m.148
      return (this.picker.nodeIds || []).map(String);
    },
    pickedNodes() {
      return this.scopeNodeIds.map((id) => nodeOf({ nodeId: id }, this.departments)).filter(Boolean);
    },
    pickedNode() {
      return this.pickedNodes[0] || null;
    },
    pickedRows() {
      return this.picker ? rowsOfNodes(this.departments, this.scopeNodeIds) : [];
    },
    pickedNames() {
      return this.pickedNodes.map((n) => this.$options.filters.translate(n.data && n.data.name) || "").filter(Boolean);
    },
    /** TKP-195: kapsamdaki veriler → satır kimlikleri (hedef çözümü için). */
    rowsByNode() {
      return Object.fromEntries(this.scopeNodeIds.map((id) => [String(id), rowsOfNodes(this.departments, [id]).map((r) => String(r._id))]));
    },
    /** TKP-195: düğüm bölümlerinde işaretli ilgili kişi satırları (kayıt bu satırlara yazılır; işaretli satırı olmayan veri kendisine). */
    pickedRowTargets() {
      if (!this.picker || ["datasubject", "rowFeature"].includes(this.edit(this.picker.section).kind)) return [];
      const ids = new Set(writeTargets({ kind: this.edit(this.picker.section).kind, nodeIds: this.scopeNodeIds, rowIds: this.picker.rowIds, cascadeRows: this.picker.cascadeRows, rowsByNode: this.rowsByNode }).filter((t) => t.rowId).map((t) => t.rowId));
      return this.pickedRows.filter((r) => ids.has(String(r._id)));
    },
    /** TKP-193: kademeli seçici ağacı (ilgili kişi satırları yalnız ilgili kişi bölümlerinde). */
    tr() {
      return (v) => this.$options.filters.translate(v) || "";
    },
    /** TKP-195: satır içi çoklu kipte ilgili kişi satırı işaretli → toplu uç yerine hedef başına tekil yazım (toplu uç satır tanımaz). */
    inlineRowTargets() {
      // TKP-214 / K7: yalnız KISMİ ilgili kişi seçimi tekil yazım ister; tam veri seçiminde toplu uç kişilere kendisi yazar
      return !!this.picker && isInlineSection(this.picker.section) && hasPartialRows({ nodeIds: this.scopeNodeIds, rowIds: this.picker.rowIds, rowsByNode: this.rowsByNode });
    },
    /** TKP-186 md.101: onay açık ve onay yetkilisi değilim → satır içi yazımlar veri başına taslağa (toplu uç yok). */
    /** TKP-242 q.2: arka plandaki toplu taslak işleminin bitiş damgası. */
    batchCompletedAt() {
      return ((this.$store && this.$store.getters) || {})["approval/batchCompletedAt"] || 0;
    },
    perNodeDrafts() {
      return bulkLocked((this.$store.getters || {})["approval/status"], this.department); // TKP-241 p.3: onaysız birimde yok
    },
    newItemForm() {
      return NEW_ITEM_FORMS[this.newItemKey] || null;
    },
    /** TKP-203: kopyalamanın süreci (kaynaklar bu süreçten) — veri kartında prop, yoksa düğümün süreci. */
    copyProcess() {
      const p = this.process || (this.node && this.node.process);
      return p && (p._id || typeof p === "string") ? (p._id ? p : { _id: p }) : null;
    },
  },
  watch: {
    reload() {
      this.load();
    },
    // TKP-242 q.2: arka plandaki toplu taslak işlemi bitti — panel yenilenir
    batchCompletedAt(n, o) {
      if (n && n !== o) this.load();
    },
    "department._id"() {
      this.releaseBulkScope();
      this.load();
    },
    "process._id"() {
      this.releaseBulkScope();
      this.load();
    },
    "node._id"() {
      this.releaseBulkScope();
      this.load();
    },
    "datasubject._id"() {
      this.releaseBulkScope();
      this.load();
    },
  },
  mounted() {
    // TKP-200 m.1: onay durumu yüklü değilse yazımlar taslak yerine toplu uca gider ve "yalnız onay yetkilisi" hatası alır —
    // panel durumu kendisi garanti eder (Envanter gibi ekranlardan da açılabiliyor)
    if (!(this.$store.getters || {})["approval/status"] && typeof this.$store.dispatch === "function") {
      const pending = this.$store.dispatch("approval/status");
      if (pending && typeof pending.catch === "function") pending.catch(() => undefined);
    }
    this.load();
  },
  beforeDestroy() {
    this.releaseBulkScope();
  },
  methods: {
    edit(key) {
      return SECTION_EDIT[key] || {};
    },
    acc(key) {
      return `hip-${this.uid}-${key}`;
    },
    pid(name) {
      return `sidebar-hip-${this.uid}-${name}`;
    },
    chevron(id) {
      return this.openSections[id] ? "bx bx-chevron-down" : "bx bx-chevron-right";
    },
    setOpen(id, value) {
      this.$set(this.openSections, id, value);
    },
    openPanel(id) {
      this.$root.$emit("bv::toggle::collapse", id);
    },
    canRemove: canRemoveItem,
    draftBadgeKey, // TKP-186
    /** Veri/ilgili kişi kapsamında ilgili kişi bölümleri satır adıyla; `feature` bölümü de satır başına.
     *  TKP-195: düğüm bölümünde satır seviyesi kayıt varsa da seviye sütunu (veri adı / ilgili kişi adı) gösterilir. */
    showRowName(section) {
      return this.single && (this.edit(section.key).kind === "datasubject" || section.key === "feature" || (section.items || []).some((x) => x && x.rowId));
    },
    /** TKP-195: seviye sütunu — satır kaydında ilgili kişi adı, veri kaydında verinin adı. */
    levelLabel(group) {
      if (group.rowName) return group.rowName;
      return this.node ? this.$options.filters.translate(this.node.data && this.node.data.name) || "" : "";
    },
    draftItem(group) {
      const x = (group.items || []).find((i) => (i.item && i.item.__draft) || i.draft);
      return x ? (x.item && x.item.__draft ? x.item : { __draft: x.draft }) : null;
    },
    draftRow(group) {
      const x = (group.items || []).find((i) => i.row && i.row.__draft);
      return x ? x.row : null;
    },
    async load() {
      if (!this.department || !this.department._id) return;
      this.loading = true;
      try {
        // TKP-200 m.19: taslakta açılmış (gölge) süreç ya da veri kapsamı sunucuda yok — ağaç taslaktan kurulur
        const shadowScope = !!((this.process && this.process.__draft) || (this.node && this.node.__draft));
        const { data } = shadowScope
          ? { data: { docs: [] } }
          : await rest.post(`${this.basePath}/paginate`, {
              pagination: { options: { page: 1, limit: 1000 }, query: {} },
              criteria: hierarchyCriteria({ department: this.department, process: this.process, node: this.node, datasubject: this.datasubject }),
            });
        // TKP-186 md.16: taslağımdaki gölge ilgili kişi satırları düğümlere katılır; envanterleri taslaktan okunur
        const drafts = (this.$store.getters || {})["approval/drafts"];
        const me = this.currentAccount && this.currentAccount._id;
        // TKP-188: veri/ilgili kişi kapsamı istemcide de daraltılır (sunucu ölçütü düğümü, satır süzgeci satırı garanti eder)
        const withShadows = withShadowRows(withShadowNodes((data && data.docs) || [], drafts, me, this.department), drafts, me); // TKP-200 m.19
        this.departments = restrictScope(this.process && this.process.__draft ? withShadows.map((d) => ({ ...d, processes: (d.processes || []).filter((p) => String(p._id) === String(this.process._id)) })) : withShadows, { node: this.node, datasubject: this.datasubject });
        const nodes = flattenNodes(this.departments);
        const processDatas = nodes.filter((e) => !e.node.__draft).map((e) => ({ _id: e.node._id })); // gölge düğümün yayımlanmış envanteri yok
        const datasources = processDatasources(this.departments).map((e) => ({ _id: e.datasource._id }));
        const datasubjects = nodes.flatMap((e) => (e.node.datasubjects || []).filter((r) => !r.__draft).map((r) => ({ _id: r._id })));
        const empty = Promise.resolve({ data: {} });
        const [ni, di, si] = await Promise.all([
          processDatas.length ? rest.post(`${this.basePath}/fetch-process-data`, { processDatas }) : empty,
          datasources.length ? rest.post(`${this.basePath}/fetch-datasource`, { datasources }) : empty,
          datasubjects.length ? rest.post(`${this.basePath}/fetch-datasubject`, { datasubjects }) : empty,
        ]);
        this.nodeInventory = overlayNodeInventory(ni.data || {}, processDatas, drafts, me);
        this.datasourceInventory = di.data || {};
        this.datasubjectInventory = overlayDatasubjectInventory(si.data || {}, nodes.flatMap((e) => e.node.datasubjects || []), drafts, me);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.loading = false;
        this.loadedOnce = true; // TKP-202 n.14
        this.picker = null;
      }
    },
    /** İmha süresi: satırın verisi (güncel süreyle) periyot formunda. */
    editPeriod(item) {
      const node = nodeOf(item, this.departments);
      if (!node) return;
      this.multiNode = false;
      this.setTargets([node]);
      this.editNode = { ...node, feature: { ...(node.feature || {}), disposalPeriod: (this.nodeInventory[String(node._id)] || {}).disposalPeriod || 0 } };
      this.$nextTick(() => this.openPanel(this.pid("disposal-period")));
    },
    /** TKP-182 md.52/81: açılan formun hedefleri (veri adları, ilgili kişi etiketleri) — panelin üstünde listelenir. */
    setTargets(nodes, rows = []) {
      this.targets = targetsOf(nodes, rows, (v) => this.$options.filters.translate(v) || "");
    },
    editRetention(key, item) {
      this.setTargets([nodeOf(item, this.departments)].filter(Boolean));
      this.retentionItem = item.item;
      this.retentionKind = this.edit(key).retention;
      this.openPanel(this.pid("retention"));
    },
    /** TKP-188 kriter 5: değer kapsamdaki tüm verilerden kaldırılır (her kaydın kendi silme ucu; onay açıkken taslağa). */
    async removeGroup(section, group) {
      const def = this.edit(section.key);
      const ids = group.ids || [];
      if (!def.remove || !ids.length) return;
      const question = ids.length > 1 ? this.$t("inventory.hierarchy.remove-all-confirm", { count: ids.length }) : this.$t("alert.approve");
      if (!(await this.confirm(question))) return;
      try {
        for (const id of ids) await this.$store.dispatch(def.remove, id);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        await this.load();
      }
    },
    openPicker(key) {
      // TKP-188 kriter 4: varsayılan kapsam alt varlıkların tümü; yalnız veri seçimi olan bölüm (tedbir) doğrudan seçime
      const def = this.edit(key);
      const rowIds = this.datasubject ? [String(this.datasubject._id)] : [];
      // TKP-195: kapsam hep ağaçtan ("Kapsam" kutusu kalktı); `cascadeRows` — süreç/veri kutusundan gelen (kademeli) satır işaretleri: yazım veriye
      // TKP-196: birim seviyesinde Ekle = doğrudan tümü (`direct`: ağaç gösterilmez); süreç seviyesinde kapsamın tümü ağaçta hazır seçili
      // (kademeli → yazım veri seviyesinde); tedbir (yalnız veri seçimi) ve onay açıkken (veri başına taslak — kullanıcı seçsin) boş açılır
      // TKP-240 b.7: ekran role göre değişmez — onay açıkken (Birim/Süreç Yöneticisi, `perNodeDrafts`) de aynı "doğrudan tümü" görünümü ve
      // hazır seçim; fark yalnız yazımda: toplu uç yerine hedef başına taslak (`inlineAllScope` false → applyPerNode, TKP-237 tek satırda gruplar)
      const direct = !this.single && this.level === "department" && !def.onlyOne;
      this.picker = { section: key, scope: "one", editOption: "ADD", items: [], value: 0, nodeIds: [], rowIds, cascadeRows: [], direct, touched: false };
      if (!this.single && !def.onlyOne) {
        this.pickAllNodes();
        this.picker.touched = false; // TKP-213: açılıştaki tümü bir ÖNERİ — ilk ilgili kişi tıklaması "yalnız bu kişi"
      }
      else if (this.single) {
        // TKP-196: kartta veri hazır seçili; ilgili kişi kartında o kişi elle işaretli (kayıt satıra), veri kartında kişiler kademeli (kayıt veriye)
        this.picker.nodeIds = this.scopeNodeIds; // TKP-233 m.148: ilgili kişisi olmayan veri seçilmez
        if (this.datasubject) { this.picker.rowIds = [String(this.datasubject._id)]; this.picker.cascadeRows = []; }
        else this.cascadeRows(rowsOfNodes(this.departments, [this.node._id]).map((r) => String(r._id)), true);
      }
    },
    // ---- TKP-173 / TKP-177 md.52 / TKP-192: satır içi kip (birim/süreç)
    isInline: isInlineSection,
    inlineDef(key) {
      return INLINE_SECTIONS[key] || {};
    },
    /** Satır içi bölüm + "seçilen veriler" kapsamında birden çok veri → kip + Uygula (istek yalnız seçili verilere). */
    /** TKP-196: satır içi bölümde kip + Uygula her seviyede — hedef (veri ya da ilgili kişi kartında tek düğüm) olduğu sürece. */
    inlineMany(key) {
      return !!this.picker && isInlineSection(key) && (this.picker.direct || this.scopeNodeIds.length >= 1);
    },
    /** Kapsamdaki bütün veriler seçili ve satır hedefi yok → toplu uç (kapsam tümü). Veri/ilgili kişi kartında ve alt kümede hedef başına. */
    inlineAllScope() {
      if (!this.picker || this.single || this.perNodeDrafts || this.inlineRowTargets) return false;
      const all = this.pickableNodeIds; // TKP-235 m.193: kapsamın tümü = ilgili kişisi olan veriler (sunucu kişisiz veriye yazmaz)
      const picked = (this.picker.nodeIds || []).map(String);
      return all.length > 0 && all.every((id) => picked.includes(id));
    },
    async onInlineSearch(key, value, callback) {
      const def = this.inlineDef(key);
      if (!def.store) return callback([]);
      try {
        const response = await this.$store.dispatch(`${def.store}/paginateForSearch`, { options: { limit: 50 }, query: { name: { value } } });
        callback(response.data?.docs ?? []);
      } catch (error) {
        callback([]);
      }
    },
    openNewItem(key) {
      if (!NEW_ITEM_FORMS[key]) return;
      this.newItemKey = key;
      this.$nextTick(() => this.openPanel(this.pid("new-item")));
    },
    /** Kütüphane formu kaydedilen kalemi bildirir → seçime eklenir (seçici açık kalır); kalem gelmezse uyarı ("en son eklenen"i aramak güvenilir değil). */
    onInlineItemCreated(created) {
      const key = this.newItemKey;
      this.openPanel(this.pid("new-item"));
      if (!this.picker || this.picker.section !== key) return;
      const item = created && (created.entity || created);
      if (item && item._id) this.picker.items = withCreatedItem(this.picker.items, { _id: item._id, name: item.name });
      else this.$toast.warning(this.$t("inventory.hierarchy.new-item-search"));
    },
    inlineRequest(key) {
      if (!this.picker || this.picker.section !== key) return null;
      if (!this.inlineAllScope()) return this.scopeNodeIds.length && (this.inlineDef(key).number ? Number(this.picker.value) > 0 : (this.picker.items || []).length) ? { perNode: true } : null; // md.101 / TKP-195/196: hedef başına
      // kapsam "tümü" (eski toplu uç davranışı). TKP-235 m.193: kapsamda ilgili kişisi olmayan veri varsa sunucuya yalnız kişili veriler
      // gider (`scope.processDatas`) — toplu uç kapsamın tümünde kişisiz veriye de yazıyordu (K7: kişisiz verinin özelliği veride)
      const nodeIds = this.pickableNodeIds.length < this.options.length ? this.pickableNodeIds : [];
      return bulkRequestFor({ section: key, editOption: this.picker.editOption, items: this.picker.items, value: this.picker.value, department: this.department, process: this.process, nodeIds });
    },
    /** TKP-186 md.101 — onay açıkken (onay yetkilisi değil): toplu uç yerine seçili her veriye tekil yazım; her istek taslağa düşer. */
    /**
     * TKP-237 t.8: toplu işlemin taslak bilgisi — seviye, bölüm, kip, yol (adlar) ve seçili veri / ilgili kişi listesi (onay ekranında
     * "Birim Envanter Özelliği - Üzerine Yaz" ve "{Birim} > {Süreç} - {liste} - {özellik}" satırları bundan yazılır).
     */
    batchMeta(section, editOption) {
      const tr = (v) => this.$options.filters.translate(v) || undefined;
      const level = { department: "DEPARTMENT", process: "PROCESS", node: "NODE", datasubject: "ROW" }[this.level];
      const rows = (this.pickedRowTargets || []).map((r) => this.rowLabel(r)).filter(Boolean);
      const nodes = this.level === "department" || this.single ? [] : this.pickedNames || [];
      // TKP-242: birim seviyesinde hedef listesi yazılmaz (görünüm "Birimin … tüm verilerinde" der) — kalabalık birimde yüzlerce ad işlem
      // başlığını 8 KB sınırının üstüne çıkarıyor, sunucu işlem bilgisini atıyordu (satırlar tek tek görünüyordu); diğer seviyelerde kısaltılır
      const targets = this.level === "department" ? "" : clipTargets([...nodes, ...rows]);
      const path = { department: tr(this.department && this.department.name), process: tr(this.process && this.process.name), data: tr(this.node && this.node.data && this.node.data.name), datasubject: tr(this.datasubject && this.datasubject.name) };
      return { kind: "FEATURE", level, section, editOption, path, ...(targets ? { targets } : {}) };
    },
    /**
     * TKP-242 q.1/q.2 — onay açık, onay yetkilisi değil: adımlar tarayıcıdan tek tek gönderilmez (her biri bildirim + taslak listesi
     * yenilemesi doğuruyordu, kalabalık birimde ekran kilitleniyordu); kaydedilip tek istekle sunucuya verilir. Ekran beklemez; işlem
     * bitince sunucu tek bildirim gönderir ve panel yenilenir (`approval/batchCompletedAt`).
     */
    async queueBackground(meta, steps, after) {
      if (!steps.length) { this.$toast.info(this.$t("inventory.hierarchy.nothing-to-write")); return; }
      try {
        const out = await runInBackground(meta, async () => {
          for (const step of steps) {
            if (step.store === "organizationProcessData/update") this.$store.commit("organizationProcessData/editedEntity", undefined);
            try {
              await this.$store.dispatch(step.store, step.action === "delete" ? step.id : step.payload);
            } catch (error) {
              /* kayıt kipinde istek gönderilmez; eylemin kendi hatası adımı düşürür */
            }
          }
        }, (body) => this.$store.dispatch("approval/startBatch", body));
        if (out.total) this.$toast.info(this.$t("approval.batch.queued", { steps: out.total }));
        if (after) after();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async applyPerNode(key) {
      const def = this.edit(key);
      const section = this.rawSections.find((s) => s.key === key);
      const rowsByNode = this.rowsByNode;
      const steps = perNodeInlinePlan({ section: key, editOption: this.picker.editOption, items: this.picker.items, value: this.picker.value, sectionItems: (section && section.items) || [], nodeIds: this.scopeNodeIds, rowIds: this.picker.rowIds, cascadeRows: this.picker.cascadeRows, rowsByNode, edit: def }); // TKP-195: satır hedefleri
      if (!steps.length) { this.$toast.info(this.$t("inventory.hierarchy.nothing-to-write")); return; }
      if (!(await this.confirm(this.$t("inventory.hierarchy.per-node-confirm", { steps: steps.length, nodes: this.scopeNodeIds.length })))) return;
      if (this.perNodeDrafts) return this.queueBackground(this.batchMeta(key, this.picker.editOption), steps, () => (this.picker = null)); // TKP-242 q.1
      this.applying = true;
      let done = 0; let failed = 0; let draft = false;
      try {
        // TKP-237 t.8: işlemin bütün adımları tek taslak satırında (onay ekranı)
        await withDraftBatch(this.batchMeta(key, this.picker.editOption), async () => {
          for (const step of steps) {
            try {
              const response = step.action === "delete" ? await this.$store.dispatch(step.store, step.id) : await this.$store.dispatch(step.store, step.payload);
              if (response && response.data && (response.data.draft || response.data.__draft)) draft = true;
              done++;
            } catch (error) {
              failed++;
            }
          }
        });
        this.$toast[failed ? "warning" : "success"](this.$t(draft ? "inventory.hierarchy.per-node-done-draft" : "inventory.hierarchy.per-node-done", { done, failed }));
        this.picker = null;
        await this.load();
      } finally {
        this.applying = false;
      }
    },
    /** Toplu güncelleme işleyicisi (kuyruk) kapsamdaki tüm düğümlere yazar; sonuç birkaç saniye içinde özette görünür. */
    async applyInline(key) {
      if (!this.inlineAllScope()) return this.applyPerNode(key); // TKP-195/196: satır hedefi, veri kartı ya da alt küme → tekil yazım
      const request = this.inlineRequest(key);
      const selected = request && request.scope && request.scope.processDatas ? request.scope.processDatas.length : 0;
      const question = selected ? this.$t("inventory.hierarchy.apply-selected-confirm", { nodes: selected }) : this.$t("inventory.hierarchy.apply-confirm", { nodes: this.nodeCount });
      if (!request || !(await this.confirm(question))) return;
      this.applying = true;
      try {
        await this.$store.dispatch("gdprInventoryBulkUpdate/update", request);
        this.$toast.success(this.$t("inventory.hierarchy.queued"));
        this.picker = null;
        setTimeout(() => this.load(), 2500);
      } catch (error) {
        if (error && error.response && error.response.status === 409) this.$toast.warning(this.$t("inventory.bulk-update.409"));
        else this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.applying = false;
      }
    },
    /** TKP-192 kriter 6 (TKP-72/74): veri kartından kaynağa bağlı kayıt silinir — aynı süreçte o kaynağı kullanan diğer verileri de etkiler (uyarı). */
    async removeSourceGroup(section, group) {
      const def = this.edit(section.key);
      const ids = group.sourceIds || [];
      if (!def.remove || !ids.length) return;
      if (!(await this.confirm(`${this.$t("process-data.inventory-panel.datasource-scope-hint")} ${this.$t("alert.approve")}`))) return;
      try {
        for (const id of ids) await this.$store.dispatch(def.remove, id);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        await this.load();
      }
    },
    /** TKP-195: seçimi temizle (Kapsam kutusunun "Veri seç"i yerine). */
    clearPick() {
      if (!this.picker) return;
      this.touchPick();
      this.picker.nodeIds = []; this.picker.rowIds = []; this.picker.cascadeRows = []; this.picker.direct = false; // elle seçime dön
    },
    pickAllNodes() {
      if (!this.picker) return;
      this.touchPick();
      this.picker.nodeIds = this.options.map((n) => n.id).filter((id) => this.pickableNodeIds.includes(id)); // TKP-233 m.148
      this.picker.rowIds = []; this.picker.cascadeRows = [];
      this.cascadeRows(this.pickedRows.map((r) => String(r._id)), true); // TKP-195: ilgili kişiler de (kademeli)
    },
    /** TKP-195: ilgili kişi kutusuna elle dokunuldu → kademeli işaret sayılmaz (kayıt o satıra yazılır). */
    onRowToggle(rowId, nodeId) {
      if (!this.picker) return;
      // TKP-196: ilgili kişi kutusu verisi seçili olmasa da işaretlenebilir — işaretlenince verisi de seçilir (kayıt yine satıra)
      // TKP-213: öneri seçimindeyken kademeli işaretli kişiye tıklamak "yalnız bu kişi" demektir (kaldırmak değil)
      Object.assign(this.picker, rowToggleSelection(this.picker, rowId, nodeId));
    },
    /** TKP-213: seçicide elle dokunuş — açılıştaki öneri seçim bitti (sonraki ilgili kişi tıklamaları ekler/çıkarır). */
    touchPick() {
      if (this.picker) this.picker.touched = true;
    },
    /** Süreç/veri kutusu: altındaki ilgili kişiler de işaretlenir (kademeli — yazım veriye); ilgili kişi tekil bölümünde (hak) satır işaretlenmez. */
    cascadeRows(rowIds, on) {
      const def = this.edit(this.picker.section);
      if (def.kind === "datasubject" && !def.multiple) { this.picker.rowIds = toggleIds(this.picker.rowIds, rowIds, false); return; }
      this.picker.rowIds = toggleIds(this.picker.rowIds, rowIds, on);
      this.picker.cascadeRows = toggleIds(this.picker.cascadeRows || [], rowIds, on);
    },
    // ---- TKP-193 kriter 1: kademeli seçici
    pickTree() {
      const tree = pickerTree(this.departments, this.tr, { withRows: true }); // TKP-194: ilgili kişi basamağı her bölümde (veri bölümlerinde bilgi amaçlı)
      return this.rowsRequired ? onlyNodesWithRows(tree) : tree; // TKP-233 m.148
    },
    processState(p) {
      return selectionState(p.nodes.map((n) => n.id), this.picker ? this.picker.nodeIds : []);
    },
    nodeState(n) {
      return selectionState(n.rows.map((r) => r.id), this.picker ? this.picker.rowIds : []);
    },
    toggleProcess(p, on) {
      if (!this.picker) return;
      this.touchPick();
      this.picker.nodeIds = toggleIds(this.picker.nodeIds, p.nodes.map((n) => n.id), on);
      this.cascadeRows(p.nodes.flatMap((n) => n.rows.map((r) => r.id)), on); // TKP-195: ilgili kişiler de (kademeli)
    },
    toggleNode(n, on) {
      if (!this.picker) return;
      this.touchPick();
      this.picker.nodeIds = toggleIds(this.picker.nodeIds, [n.id], on);
      this.cascadeRows(n.rows.map((r) => r.id), on); // TKP-195: ilgili kişiler de (kademeli)
    },
    // ---- TKP-194: bölüm başına tek ağaç
    sectionTree(section) {
      return sectionTree(section, this.departments, this.tr);
    },
    branchKey(sectionKey, kind, id) {
      return `${sectionKey}|${kind}:${id}`;
    },
    branchOpen(sectionKey, kind, id) {
      const k = this.branchKey(sectionKey, kind, id);
      // TKP-195: veri / ilgili kişi kartında (tek düğüm) dallar varsayılan AÇIK — satır kaydı ile veri kaydı bir arada görünsün
      return k in this.openNodes ? !!this.openNodes[k] : !!this.node;
    },
    toggleBranch(sectionKey, kind, id) {
      const k = this.branchKey(sectionKey, kind, id);
      this.$set(this.openNodes, k, !this.branchOpen(sectionKey, kind, id));
    },
    /** Birim/süreç/veri/ilgili kişi satırındaki "+ Ekle": seçici o kapsamla hazır açılır (TKP-194 kriter 3). */
    openPickerAt(key, { nodeIds = [], rowIds = [], cascade = false } = {}) {
      this.openPicker(key);
      if (!this.picker) return;
      this.picker.direct = false; // süreç/veri/ilgili kişi Ekle'si ağaçla
      this.picker.nodeIds = (nodeIds || []).map(String);
      this.picker.rowIds = (rowIds || []).map(String); // satırın kendi + Ekle'si: elle dokunulmuş sayılır (kayıt satıra)
      this.picker.cascadeRows = [];
      // süreç/veri satırının Ekle'si: altındaki ilgili kişiler de işaretli (kademeli → yazım veri seviyesinde)
      if (cascade) this.cascadeRows(rowsOfNodes(this.departments, this.picker.nodeIds).map((r) => String(r._id)), true);
    },
    /** TKP-194: veri satırında düzenlenebilen bölümler ve kalem eylemi. */
    nodeEditable(key) {
      return key === "disposalPeriod" || key === "measures" || key === "accessAndRestrictions" || !!this.edit(key).retention; // TKP-196: erişim tekil düzenleme
    },
    editNodeValue(key, v) {
      const item = v.items && v.items[0];
      if (!item) return;
      if (key === "disposalPeriod") return this.editPeriod(item);
      if (key === "measures") return this.editMeasures(item);
      if (key === "accessAndRestrictions" && item.item) return this.editAccessItem(item);
      if (this.edit(key).retention && item.item) return this.editRetention(key, item);
    },
    rowEditable(key) {
      return key === "feature" || !!this.edit(key).rowEdit || this.nodeEditable(key); // TKP-195: süre/tedbir/saklama satırda da
    },
    editRowValue(key, v) {
      const item = v.items && v.items[0];
      if (!item) return;
      if (key === "feature") return this.editFeature(item);
      if (this.edit(key).rowEdit && item.item) return this.editRow(key, item);
      if (key === "disposalPeriod") return this.editRowPeriod(item);
      if (key === "measures") return this.editRowMeasures(item);
      if (key === "accessAndRestrictions" && item.item) return this.editAccessItem(item);
      if (this.edit(key).retention && item.item) return this.editRetention(key, item);
    },
    /** TKP-195: satırın saklama süresi — periyot formu hazırlama kipinde, yük satıra (`updateFeature`). */
    editRowPeriod(item) {
      const node = nodeOf(item, this.departments);
      const row = item.row || this.rowOf(item);
      if (!node || !row) return;
      this.multiNode = true;
      this.prepareNodeIds = [];
      this.prepareRowIds = [String(row._id)];
      this.setTargets([node], [row]);
      this.editNode = { ...node, feature: { ...(node.feature || {}), disposalPeriod: (this.datasubjectInventory[String(row._id)] || {}).disposalPeriod || 0 } };
      this.$nextTick(() => this.openPanel(this.pid("disposal-period")));
    },
    /** TKP-195: satırın tedbirleri — tedbir formu hazırlama kipinde, satırın mevcut tedbirleriyle. */
    editRowMeasures(item) {
      const node = nodeOf(item, this.departments);
      const row = item.row || this.rowOf(item);
      if (!node || !row) return;
      const inv = this.datasubjectInventory[String(row._id)] || {};
      this.multiNode = true;
      this.prepareNodeIds = [];
      this.prepareRowIds = [String(row._id)];
      this.setTargets([node], [row]);
      this.measuresNode = { ...node, administrativeMeasures: inv.administrativeMeasures || [], technicalMeasures: inv.technicalMeasures || [] };
      this.$nextTick(() => this.openPanel(this.pid("measures")));
    },
    /** Değer çipindeki 🗑: verilen kayıtlar silinir (birim/süreçte altındaki tümü — sayı onayda; veri/ilgili kişide tek kayıt). */
    async removeIds(key, ids) {
      const def = this.edit(key);
      const list = (ids || []).filter(Boolean);
      if (!def.remove || !list.length) return;
      const question = list.length > 1 ? this.$t("inventory.hierarchy.remove-all-confirm", { count: list.length }) : this.$t("alert.approve");
      if (!(await this.confirm(question))) return;
      try {
        for (const id of list) await this.$store.dispatch(def.remove, id);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        await this.load();
      }
    },
    // ---- TKP-193 kriter 3: değer satırı altındaki ağaç
    treeKey(sectionKey, groupKey) {
      return `${sectionKey}\u0003${groupKey}`;
    },
    treeOpen(sectionKey, groupKey) {
      return !!this.openTrees[this.treeKey(sectionKey, groupKey)];
    },
    toggleTree(sectionKey, groupKey) {
      const k = this.treeKey(sectionKey, groupKey);
      this.$set(this.openTrees, k, !this.openTrees[k]);
    },
    groupTree(group) {
      return groupTree(group, this.departments, this.tr);
    },
    canRemoveAny(key, items) {
      return (items || []).some((x) => canRemoveItem(key, x));
    },
    /** Ağaç yaprağı: o veri/ilgili kişideki kayıt(lar) silinir (taslak kayıt hariç). */
    async removeItems(key, items) {
      const def = this.edit(key);
      const ids = (items || []).filter((x) => canRemoveItem(key, x)).map((x) => x.item._id);
      if (!def.remove || !ids.length || !(await this.confirm(this.$t("alert.approve")))) return;
      try {
        for (const id of ids) await this.$store.dispatch(def.remove, id);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        await this.load();
      }
    },
    pickAllRows() {
      if (!this.picker) return;
      this.picker.rowIds = this.pickedRows.map((r) => String(r._id));
    },
    /** Birden çok veri kapsamında ilgili kişi satırı "Veri › İlgili kişi" etiketiyle. */
    rowLabel(row) {
      const name = this.$options.filters.translate(row.name) || "";
      if (this.scopeNodeIds.length < 2) return name;
      const node = nodeOf({ nodeId: row.nodeId }, this.departments);
      return `${this.$options.filters.translate(node && node.data && node.data.name) || ""} › ${name}`;
    },
    canContinue(key) {
      if (!this.picker || !this.scopeNodeIds.length) return false;
      const def = this.edit(key);
      if (!["datasubject", "rowFeature"].includes(def.kind)) return true;
      return def.multiple ? this.picker.rowIds.length > 0 : this.picker.rowIds.length === 1;
    },
    /** Seçimden sonra form: aynı store commit'leri, aynı form her seviyede. Birden çok hedef → form hazırlama kipinde / kalem `onPick` ile, hedef başına yazım. */
    startAdd(key) {
      const def = this.edit(key);
      const node = this.pickedNode;
      if (!node) return;
      const nodeIds = this.scopeNodeIds;
      this.pickSection = key;
      // TKP-195: düğüm bölümlerinde hedef en derin işaretli seviye — işaretli satırlar satıra, işaretli satırı olmayan veriler kendine
      const targets = ["datasubject", "rowFeature"].includes(def.kind) ? [] : writeTargets({ kind: def.kind, nodeIds, rowIds: this.picker.rowIds, cascadeRows: this.picker.cascadeRows, rowsByNode: this.rowsByNode });
      const rowTargets = targets.filter((t) => t.rowId).map((t) => t.rowId);
      const nodeTargets = targets.filter((t) => !t.rowId).map((t) => t.nodeId);
      this.pickRowIds = rowTargets;
      this.pickNodeIds = ["datasubject", "rowFeature"].includes(def.kind) ? nodeIds : nodeTargets; // hedefler burada çözüldü; `onPick` olduğu gibi kullanır
      this.pickEditOption = this.picker.editOption || "ADD"; // TKP-196: kip panelde uygulanır
      // TKP-196: kip Ekle değilse form her zaman hazırlama kipinde (panel siler/yazar); tek veri + Ekle'de form kendisi kaydeder (eski yol)
      const kipForces = this.pickEditOption !== "ADD" && ["node", "feature", "measures"].includes(def.kind);
      this.multiNode = (nodeIds.length > 1 || rowTargets.length > 0 || kipForces) && ["node", "feature", "measures", "period"].includes(def.kind);
      this.prepareNodeIds = this.multiNode ? nodeTargets : [];
      this.prepareRowIds = this.multiNode ? rowTargets : [];
      this.setTargets(this.pickedNodes, this.pickedRowTargets.map((r) => this.rowLabel(r)));
      this.storageNodeId = String(node._id); // tek veri: saklama formu bu düğümün mevcut kayıtlarını bilir (md.28/29)
      if (def.kind === "measures") {
        // TKP-196: çoklu / kipli yazımda form BOŞ açılır (seçilen tedbirler kipe göre her hedefe uygulanır); tek veride mevcut liste
        this.measuresNode = this.multiNode ? { ...node, administrativeMeasures: [], technicalMeasures: [] } : node;
        this.picker = null;
        this.$nextTick(() => this.openPanel(this.pid(def.panel)));
        return;
      }
      if (def.kind === "period") {
        this.editNode = { ...node, feature: { ...(node.feature || {}), disposalPeriod: (this.nodeInventory[String(node._id)] || {}).disposalPeriod || 0 } };
        this.picker = null;
        this.$nextTick(() => this.openPanel(this.pid(def.panel)));
        return;
      }
      if (def.kind === "node") {
        this.$store.commit(`${def.store}/editedData`, { _id: node._id, name: node.data && node.data.name, processData: { _id: node._id } });
        if (key === "accessAndRestrictions") this.$store.commit("dataAccessAndRestriction/editedAccessAndRestriction", null); // TKP-222 p.6: Ekle boş form
      } else if (def.kind === "feature") {
        // TKP-74: veri kartından eklenen toplama/saklama/arşiv kaydı DÜĞÜME yazılır — kaynak gerekmez
        this.$store.commit(`${def.store}/editedDatasource`, null);
        this.$store.commit(`${def.store}/editedProcessData`, { _id: node._id });
        if (def.edited) this.$store.commit(`${def.store}/${def.edited}`, {});
      } else if (def.kind === "rowFeature") {
        // TKP-196: Otomatik / YZ işleme — seçilen ilgili kişi satırlarına aynı değerler (form hazırlama kipinde, panel satır başına yazar)
        const rows = this.pickedRows.filter((r) => this.picker.rowIds.includes(String(r._id)));
        this.pendingRowIds = rows.map((r) => r._id);
        this.setTargets(this.pickedNodes, rows.map((r) => this.rowLabel(r)));
        this.addMode = true;
        this.$store.commit("datasubjectProcessingLegal/editedDatasubject", rows[0]);
      } else if (def.kind === "datasubject") {
        const rows = this.pickedRows.filter((r) => this.picker.rowIds.includes(String(r._id)));
        this.pendingRowIds = rows.map((r) => r._id);
        this.setTargets(this.pickedNodes, rows.map((r) => this.rowLabel(r)));
        this.addMode = !!def.multiple; // çoklu yazım panelde; tek satırda form kendisi kaydeder
        this.$store.commit(`${def.store}/editedDatasubject`, rows[0]);
        if (key === "processingLegals") this.$store.commit("datasubjectProcessingLegal/editedDatasubjectProcessingLegal", null);
        if (key === "transferings") {
          this.$store.commit("datasubjectTransfering/editedDatasubjectTransfering", null);
          // TKP-182 md.93/94: eklemede de işleme kısayolu — seçili ilgili kişilerin işleme kayıtlarının birleşimi
          this.$store.commit("datasubjectTransfering/processingLegalSource", processingLegalSourceOf(this.pendingRowIds, this.datasubjectInventory));
        }
      }
      this.picker = null;
      this.openPanel(this.pid(def.panel));
    },
    /**
     * TKP-188 kriter 2/4/8: kütüphane listeli formdan seçilen kalem — kapsamdaki her hedefe (veri; hak bölümünde ilgili kişi satırı)
     * tekil `addFromLibrary`; hedefte zaten varsa atlanır. Her istek taslak kapısından geçer; form açık kalır, özet yenilenir.
     */
    async onPick(libraryItem) {
      const key = this.pickSection;
      const section = this.rawSections.find((s) => s.key === key);
      if (!key || !section) return;
      const def = this.edit(key);
      const steps = pickWritePlan({ section: key, items: [libraryItem], sectionItems: section.items, nodeIds: this.pickNodeIds, rowIds: def.kind === "datasubject" ? this.pendingRowIds : this.pickRowIds, edit: def });
      if (!steps.length) { this.$toast.info(this.$t("inventory.hierarchy.nothing-to-write")); return; }
      await this.writeSteps(steps, this.$options.filters.translate(libraryItem && libraryItem.name) || "", this.batchMeta(key, "ADD"));
    },
    /** İmha süresi, birden çok veri: aynı süre seçilen her veriye (düğüm başına tekil uç). */
    async onPeriodPrepared(value) {
      if (!this.multiNode) return;
      await this.writeSteps(periodWritePlan({ value, nodeIds: this.prepareNodeIds, rowIds: this.prepareRowIds }), "", this.batchMeta("disposalPeriod", "OVERRIDE"));
      this.multiNode = false;
      this.prepareNodeIds = [];
      this.prepareRowIds = [];
      this.$emit("onNodeSaved");
    },
    async writeSteps(steps, label, meta) {
      if (this.perNodeDrafts) return this.queueBackground(meta, steps); // TKP-242 q.1
      this.applying = true;
      let done = 0; let failed = 0; let draft = false;
      try {
        await withDraftBatch(meta, async () => { // TKP-237 t.8
          for (const step of steps) {
            try {
              const response = await this.$store.dispatch(step.store, step.payload);
              if (response && response.data && (response.data.draft || response.data.__draft)) draft = true;
              done++;
            } catch (error) {
              failed++;
            }
          }
        });
        this.$toast[failed ? "warning" : "success"](this.$t(draft ? "inventory.hierarchy.written-draft" : "inventory.hierarchy.written", { done, failed, name: label }));
      } finally {
        this.applying = false;
        await this.load();
      }
    },
    // ---- TKP-177 md.54/57: satırdan düzenleme (envanter ekranındaki akış: işleme = satırın tüm listesi, aktarım = tek kayıt)
    rowOf(item) {
      return rowsOfNodes(this.departments, [item.nodeId]).find((r) => String(r._id) === String(item.rowId)) || null;
    },
    editRow(key, item) {
      const def = this.edit(key);
      const row = this.rowOf(item);
      if (!row || !def.rowEdit) return;
      if (key === "processingLegals" && item.item && item.item._id) return this.editProcessingItem(item, row); // TKP-196: tekil kayıt
      const legals = (this.datasubjectInventory[String(row._id)] || {}).processingLegals || [];
      this.addMode = false;
      this.multiNode = false;
      this.setTargets([nodeOf(item, this.departments)].filter(Boolean), [row]);
      if (key === "processingLegals") {
        this.$store.commit("datasubjectProcessingLegal/editedDatasubject", row);
        this.$store.commit("datasubjectProcessingLegal/editedDatasubjectProcessingLegal", editableLegals(legals)); // TKP-186: taslak kalemler de kümede
      } else {
        this.$store.commit("datasubjectTransfering/processingLegalSource", legals); // TKP-64 kısayolları bu satırdan okur
        this.$store.commit("datasubjectTransfering/editedDatasubject", row);
        this.$store.commit("datasubjectTransfering/editedDatasubjectTransfering", item.item);
      }
      this.openPanel(this.pid(def.panel));
    },
    /** TKP-196 kriter 5: yalnız bu işleme kaydı (amaç / hukuki sebep / meşru menfaat); kümenin diğer kayıtları dokunulmaz. */
    editProcessingItem(item, row = this.rowOf(item)) {
      if (!row) return;
      const items = ((this.datasubjectInventory[String(row._id)] || {}).processingLegals || []).filter((x) => x && !x.__draft);
      this.addMode = false;
      this.multiNode = false;
      this.setTargets([nodeOf(item, this.departments)].filter(Boolean), [row]);
      this.itemEdit = { item: item.item, items, row };
      this.$nextTick(() => this.openPanel(this.pid("processing-item")));
    },
    /** TKP-196 kriter 5: erişim kaydını tekil düzenle (erişen kişi / kısıt) — form kendisi günceller (`_id` ile). */
    editAccessItem(item) {
      const rec = item.item;
      if (!rec || !rec._id) return;
      const node = nodeOf(item, this.departments);
      const row = item.rowId ? this.rowOf(item) : null;
      this.multiNode = false;
      this.pickEditOption = "ADD";
      this.setTargets([node].filter(Boolean), row ? [row] : []);
      // TKP-222 p.6: kayıt kendi seviyesinde kalır — ilgili kişi satırının kaydı satıra (eskiden düzenleme veriye yazıyordu)
      this.$store.commit("dataAccessAndRestriction/editedData", node ? { _id: node._id, name: node.data && node.data.name, ...(row ? { datasubject: { _id: row._id } } : { processData: { _id: node._id } }) } : null);
      // kütüphane erişen kişisi kimlik olarak gelir; seçici ad ister → ad organizasyon erişen kişisinden (kütüphane kaleminden türemiştir)
      const libId = rec.libraryItem && rec.libraryItem._id ? rec.libraryItem._id : rec.libraryItem;
      const libraryItem = libId ? { _id: libId, name: (rec.libraryItem && rec.libraryItem.name) || (rec.accessor && rec.accessor.name) } : rec.accessor ? { _id: rec.accessor._id, name: rec.accessor.name } : undefined;
      this.$store.commit("dataAccessAndRestriction/editedAccessAndRestriction", { _id: rec._id, libraryItem, restriction: rec.restriction && rec.restriction._id ? rec.restriction : undefined });
      this.$nextTick(() => this.openPanel(this.pid("access")));
    },
    // ---- TKP-177 md.53: tedbir ve otomatik işleme düzenleme
    editMeasures(item) {
      const node = item.node || nodeOf(item, this.departments);
      if (!node) return;
      this.$store.commit("organizationProcessData/editedEntity", undefined); // TKP-200 m.17: başka düğümün kaydı yüke karışmasın
      this.multiNode = false;
      this.setTargets([node]);
      this.measuresNode = node;
      this.$nextTick(() => this.openPanel(this.pid("measures")));
    },
    editFeature(item) {
      const row = item.row || this.rowOf(item);
      if (!row) return;
      this.addMode = false; // tek satır: form kendisi kaydeder
      this.setTargets([nodeOf(item, this.departments)].filter(Boolean), [row]);
      this.$store.commit("datasubjectProcessingLegal/editedDatasubject", row);
      this.openPanel(this.pid("feature"));
    },
    /** TKP-196: hazırlanan Otomatik / YZ değerleri seçili her satıra (`updateFeature`). */
    async onFeaturePrepared(values) {
      // TKP-196: kip standart — Ekle / Üzerine yaz formdaki değerleri yazar; Kaldır formda Evet seçilen alanları Hayır'a döndürür (diğerine dokunmaz)
      const remove = this.pickEditOption === "REMOVE";
      const payloadOf = (id) => (remove ? { _id: id, ...(values.autoProcessing ? { autoProcessing: false } : {}), ...(values.aiProcessing ? { aiProcessing: false } : {}) } : { _id: id, autoProcessing: !!values.autoProcessing, aiProcessing: !!values.aiProcessing });
      const steps = (this.pendingRowIds || []).map((id) => payloadOf(String(id && id._id ? id._id : id))).filter((p) => Object.keys(p).length > 1).map((payload) => ({ action: "update", store: "organizationProcessDataDatasubject/updateFeature", payload }));
      await this.runSteps(steps, "autoProcessing");
    },
    async onFeatureSaved() {
      this.$root.$emit("bv::toggle::collapse", this.pid("feature"));
      await this.load();
    },
    /** Düğüm alanı (tedbir / imha süresi) değişti: veri kartı yenilensin. */
    onNodeSaved() {
      this.$emit("onNodeSaved");
      this.load();
    },
    // ---- TKP-177 md.52: hazırlama kipinde gelen yük seçili her düğüme ayrı yazılır
    async onAccessPrepared(payload) {
      if (!this.multiNode) return;
      // TKP-196: kip — Üzerine yaz hedefin erişim kayıtlarını siler, Kaldır erişen kişiyle eşleşeni siler
      await this.runSectionSteps("accessAndRestrictions", accessKipPlan({ editOption: this.pickEditOption, nodeIds: this.prepareNodeIds, rowIds: this.prepareRowIds, payload, nodeInventory: this.nodeInventory, datasubjectInventory: this.datasubjectInventory }));
    },
    /** TKP-196: kip adımları sırayla (silme id ile, yazma yükle); sonunda hazırlama durumu sıfırlanır, özet yenilenir. */
    /** TKP-237 t.8: bölüm anahtarı önde (taslak bilgisi için). */
    runSectionSteps(section, steps) {
      return this.runSteps(steps, section);
    },
    async runSteps(steps, section) {
      if (this.perNodeDrafts && steps.length) {
        // TKP-242 q.1: taslağa yazılan kip adımları arka planda
        await this.queueBackground(this.batchMeta(section || this.pickSection, this.pickEditOption || "ADD"), steps);
        this.addMode = false;
        this.multiNode = false;
        this.prepareNodeIds = [];
        this.prepareRowIds = [];
        return;
      }
      try {
        if (!steps.length) this.$toast.info(this.$t("inventory.hierarchy.nothing-to-write"));
        await withDraftBatch(this.batchMeta(section || this.pickSection, this.pickEditOption || "ADD"), async () => { // TKP-237 t.8
          for (const step of steps) {
            // TKP-200 m.17: CRUD güncellemesi yükü store'daki düzenleme kaydıyla birleştirir — kalmış kayıt (başka düğüm) karışmasın
            if (step.store === "organizationProcessData/update") this.$store.commit("organizationProcessData/editedEntity", undefined);
            await this.$store.dispatch(step.store, step.action === "delete" ? step.id : step.payload);
          }
        });
        if (steps.length) this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.addMode = false;
        this.multiNode = false;
        this.prepareNodeIds = [];
        this.prepareRowIds = [];
        await this.load();
      }
    },
    /** TKP-182 md.28/29: düğümün kendi saklama kayıtları (ortam zaten ekliyse form dolu alanları o kayda yazar). */
    storageExisting(key, nodeId = this.storageNodeId) {
      return ((this.nodeInventory[String(nodeId)] || {}).own || {})[key] || [];
    },
    async onStoragePrepared(key, payload) {
      if (!this.multiNode) return;
      const def = this.edit(key);
      // TKP-195: satır hedefleri satırın kendi saklama kayıtlarıyla; TKP-196: kip (Üzerine yaz / Kaldır) ortamla eşleşir
      const ownOf = (t) => (t.rowId ? ((this.datasubjectInventory[String(t.rowId)] || {}).own || {})[key] || [] : this.storageExisting(key, t.nodeId));
      await this.runSectionSteps(key, storageKipPlan({ editOption: this.pickEditOption, store: def.store, kind: def.retention, nodeIds: this.prepareNodeIds, rowIds: this.prepareRowIds, payload, ownOf }));
    },
    async onMeasuresPrepared(form) {
      if (!this.multiNode) return;
      // TKP-196: kip — Ekle birleşim, Üzerine yaz formdaki liste, Kaldır çıkarır; düğüm ve satır (TKP-195) hedefleri
      // TKP-200 m.17: düğümde bekleyen taslak tedbirler kipin tabanıdır (yayımlanmış liste değil)
      const drafts = (this.$store.getters || {})["approval/drafts"];
      const me = this.currentAccount && this.currentAccount._id;
      const existingOf = (t) => (t.rowId ? this.datasubjectInventory[String(t.rowId)] || {} : { ...(nodeOf({ nodeId: t.nodeId }, this.departments) || {}), ...(draftNodeMeasuresOf(drafts, t.nodeId, me) || {}) });
      await this.runSectionSteps("measures", measuresKipPlan({ editOption: this.pickEditOption, nodeIds: this.prepareNodeIds, rowIds: this.prepareRowIds, form, existingOf }));
      this.$emit("onNodeSaved");
    },
    async onProcessingPrepared(items) {
      // TKP-196: kip — Üzerine yaz satırın kümesini formdakiyle değiştirir, Kaldır amaç+hukuki sebep eşleşenleri kümeden düşer
      await this.runSectionSteps("processingLegals", processingKipPlan({ editOption: this.pickEditOption, rowIds: this.pendingRowIds, items, inventory: this.datasubjectInventory }));
    },
    async onTransferingPrepared(prepared) {
      // TKP-196: kip — Üzerine yaz satırın aktarımlarını siler, Kaldır üçüncü tarafla eşleşeni siler
      await this.runSectionSteps("transferings", transferingKipPlan({ editOption: this.pickEditOption, rowIds: this.pendingRowIds, prepared, inventory: this.datasubjectInventory }));
    },
    async writeAll(payloads, action) {
      try {
        for (const payload of payloads) await this.$store.dispatch(action, payload);
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      } finally {
        this.addMode = false;
        this.multiNode = false;
        this.prepareNodeIds = [];
        this.prepareRowIds = [];
        await this.load();
      }
    },
    // ---- Toplu Güncelleme sekmesi (TKP-173): birim/süreç kapsamı; veri/ilgili kişi kartında düğüm (+ satır) kapsamı (TKP-72/76)
    openBulkScope() {
      if (this.bulkScoped) return;
      try {
        const commits = this.node
          ? panelScope(nodeScopeCommits({ department: this.department, process: this.process || this.node.process, node: this.node }), this.datasubject)
          : hierarchyScopeCommits({ department: this.department, process: this.process });
        this.criteriaBefore = JSON.parse(JSON.stringify(this.$store.getters["inventoryFilter/criteria"] ?? {}));
        this.$store.commit("inventoryFilter/clear");
        commits.forEach(([mutation, value]) => this.$store.commit(`inventoryFilter/${mutation}`, value));
        if (!this.node) this.$store.commit("gdprInventoryBulkUpdate/scopeProcess", this.process && this.process._id ? this.process : undefined);
        this.bulkScoped = true;
      } catch (error) {
        this.$toast.warning(this.$t("process-data.inventory-panel.no-scope"));
      }
    },
    releaseBulkScope() {
      if (!this.bulkScoped) return;
      this.$store.commit("inventoryFilter/criteria", this.criteriaBefore ?? {});
      if (!this.node) this.$store.commit("gdprInventoryBulkUpdate/resetScope");
      this.bulkScoped = false;
      this.criteriaBefore = null;
    },
    onBulkUpdated() {
      setTimeout(() => this.load(), 2500);
    },
  },
};
</script>
